export const getColumnNumber = (index) =>
  String(index).length === 1 ? String(index).padStart(2, '0') : index;
